<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('usersmanage.pageTitleText') }}
            p Manage users and their roles.
            strong(v-if="$store.getters.isAdmin") You have created {{ usage.used }} of {{ usage.max }} users.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="$store.getters.isAdmin"
            :userCanIndex="true"
            :userCanDelete="$store.getters.isAdmin"
            :actionInTable="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="username"
            :primarySearchKeyI18="$t('usersmanage.userName')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','UsersManage')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','UsersManage')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','UsersManage')"
        )
            template(slot="tableUpperBtn")
                InviteUserBtn(v-if="$can('write', 'groupResourcesPermission','UsersManage') && $store.state.queryGroupName !== 'all'" )
</template>
<script>
import Vue from "vue";
import RcmTable from "@/components/RcmTable_v2";
import StringList from "@/components/StringList";
import TagList from "../../components/TagList.vue";
import bus from "@/libs/bus.js";
import { getGroupAsset } from "@/api/groupasset.js";
import { getFormOptions } from "@/api/formoptions";
import { changeUserRole } from "@/api/user";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import loginAndLogoutRecordsInfosBtn from "@/components/loginAndLogoutRecordsInfosBtn"
import InviteUserBtn from "@/components/InviteUserBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("loginAndLogoutRecordsInfosBtn",loginAndLogoutRecordsInfosBtn)
Vue.component("InviteUserBtn", InviteUserBtn);
Vue.component("StringList", StringList);
Vue.component("TagList", TagList);

import { settingZoneExplain, isEnabled, username, groupName, action } from "./fields.js";

export default {
    name: "UsersManage",
    components: { RcmTable, StringList },
    data() {
        return {
            esIndex: "rcm-users",
            drawerTitleKey: "username",
            userRoleOptions: [],
            assetCategory: "users",
            usage: { used: "", max: "", available: "" },
        };
    },
    computed: {
        addButtonText() {
            return this.$store.getters.isAdmin
                ? this.$i18n.t("usersmanage.createText")
                : this.$i18n.t("usersmanage.inviteText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      username: username(this),
                      _id: {},
                      password: {},
                      email: {},
                      privilege: {},
                      inGroupsRole: {},
                      isenabled: isEnabled(this),
                      //   reset: {},
                      status: {},
                      objectLog: {},
                      isUseUserAllowIp: {},
                      userAllowIp: {},
                      lastModifiedPasswordDate: {},
                      lastModifiedOtpTokenDate: {},
                      trustedIpAndDevice: {},
                      loginInfos:{},
                      modifiedDate: {},
                      createBy: {},
                  }
                : {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain,
                      groupName: groupName(this),
                      username: username(this),
                      _id: {},
                      password: {},
                      email: {},
                      userRoleName: {
                          filter: {
                              type: "string",
                              searchKey: "inGroupsRole.roleName",
                          },
                          render: (h, params) => {
                              var self = this;
                              return h(
                                  "Select",
                                  {
                                      props: {
                                          value: params.row.inGroupsRole.find(
                                              (e) => e.groupName == self.$store.state.queryGroupName
                                          ).roleName,
                                          transfer: true,
                                          disabled: self.$refs.rcmTable.isEditBtnDisabled,
                                      },
                                      on: {
                                          "on-change": (roleName) => {
                                              var self = this;
                                              if (roleName !== undefined) {
                                                  changeUserRole({
                                                      userName: params.row.username,
                                                      groupName: self.$store.state.queryGroupName,
                                                      roleName: roleName,
                                                  })
                                                      .then((result) => {
                                                          self.$Notice.success({
                                                              title: this.$i18n.t("global.success"),
                                                              desc: `${result.data.message}`,
                                                          });
                                                      })
                                                      .catch(function (error) {
                                                          self.$Notice.warning({
                                                              title: this.$i18n.t("global.error"),
                                                              desc: `${error}`,
                                                          });
                                                          self.$refs.rcmTable.getTableData();
                                                      });
                                              }
                                          },
                                      },
                                  },
                                  this.userRoleOptions.map((roleName) =>
                                      h(
                                          "Option",
                                          {
                                              props: { value: roleName },
                                          },
                                          roleName
                                      )
                                  )
                              );
                          },
                      },
                      // isenabled: {},
                      //   reset: {},
                      status: {},
                      objectLog: {},
                      isUseUserAllowIp: {},
                      userAllowIp: {},
                      createdDate: {},
                      modifiedDate: {},
                      createBy: {},
                  };
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
        getFormOptions(`/rolenames?groupName=${this.$store.state.queryGroupName}`).then((res) => {
            this.userRoleOptions = res.data.options;
        });
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/UsersManage/Page.vue